// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pod-metrics-chooser[data-v-1ee997a9]{width:-moz-fit-content;width:fit-content;margin-bottom:10px;min-width:300px}", ""]);
// Exports
module.exports = exports;
